import { ASSETS } from "assets";
import { Formik } from "formik";
import AuthenticationForm from "lib/components/authentication/authentication-form";
import ErrorBox from "lib/components/common/error-box";
import FlexBox from "lib/components/common/flex-box";
import Hyperlink from "lib/components/common/hyperlink";
import AuthenticationLayout from "lib/components/layouts/authentication";
import { DEFAULT_RESET_PASSWORD_VALUES } from "lib/constants/default-values";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { EMAIL_VALIDATION_SCHEMA,FORGOT_PASSWORD_VALIDATION_SCHEME } from "lib/constants/validation-constants";
import useAuthentication from "lib/hooks/useAuthentication";
import { Button, Image, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const ResetPassword = () => {
  const { resetPassword, loading, error } = useAuthentication();
  const navigateTo = useNavigate();

  const handleSuccess = () => {
    toast.success("Password reset link sent to your email");
    window.setTimeout(() => navigateTo(PAGE_ROUTES.AUTHENTICATION.Login), 3000);
  };

  return (
    <AuthenticationLayout>
      <FlexBox className="h-100" justifyContent="around">
        <Image
          src={ASSETS.IMAGES.LOGIN_IMAGE}
          alt="Sign In"
          className="login-image"
        />
        <AuthenticationForm isLoading={loading}>
          <FlexBox justifyContent="start" className="mb-4 mx-2">
            <h2>Reset Password</h2>
          </FlexBox>
          <Formik
            initialValues={DEFAULT_RESET_PASSWORD_VALUES}
            validationSchema={FORGOT_PASSWORD_VALIDATION_SCHEME}
            onSubmit={(values: ForgotPasswordRequest) =>
              resetPassword(values, handleSuccess)
            }
          >
            {({ values, handleChange, handleBlur, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-group">
                  <Form.Label>
                    Email <span className="login-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={values.email}
                    className="form-control"
                    onChange={handleChange}
                    onBeforeInput={handleBlur}
                    required
                  />
                </Form.Group>
                {error && <ErrorBox message={error} />}
                <Form.Group className="form-group login-btn text-center">
                  <Button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary px-4"
                  >
                    Submit
                  </Button>
                </Form.Group>
              </Form>
            )}
          </Formik>
          <p className="text-center px-4 mt-2">
            Back to{" "}
            <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.Login}>Sign In</Hyperlink>
          </p>
        </AuthenticationForm>
      </FlexBox>
    </AuthenticationLayout>
  );
};

export default ResetPassword;
